var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.timer > 0 ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "alert box-shadow mb-2",
    class: _vm.className,
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm.should_auto_close ? _c('span', {
    staticClass: "loader"
  }, [_vm._v(_vm._s(_vm.timer))]) : _vm._e(), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _c('div', {
    staticClass: "pr-2",
    class: _vm.icon
  }), _vm._t("default")], 2)]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }